const r = {
  styleOverrides: {
    root: ({ theme: e }) => ({
      borderRadius: "8px",
      backgroundColor: e.palette.grey[100]
    }),
    bar: {
      borderRadius: "8px"
    }
  },
  variants: [
    {
      props: {
        size: "small"
      },
      style: {
        height: "8px"
      }
    },
    {
      props: {
        size: "medium"
      },
      style: {
        height: "12px"
      }
    },
    {
      props: {
        size: "large"
      },
      style: {
        height: "16px"
      }
    }
  ]
};
export {
  r as linearProgress
};
//# sourceMappingURL=linearProgress.mjs.map
